import React, {useEffect, useState} from "react";

export function Radio(props) {
  const [selected_value, setSelectedValue] = useState(props.checked);
  const [input, setInput] = useState(props.input);

  useEffect(() => {
    setSelectedValue(props.checked);
  });

  const onChangeValue = (event) => {
    setSelectedValue(event.target.value);

    props.cb({input: input, value: event.target.value});
  }

  return (
    <div className="flex items-center gap-8 justify-center" onChange={onChangeValue}>
      {
        props.buttons.map(b => {
          return (
            <label className="inline-flex items-center">
              <input type="radio" value={b.value} checked={selected_value === b.value} className="h-5 w-5 text-red-600"/>
              <span className="ml-2 text-gray-700">{b.placeholder}</span>
            </label>
          )
        })
      }
    </div>
  );
}
